(function () {
  'use strict';

  function factory($window) {
    'ngInject';

    return {
      small: $window.matchMedia('(max-width: 549px)'),
    };
  }

  angular
    .module('hq.tools.lighting')
    .factory('hqTLightingMediaquery', factory);
}());
